import {DateTime} from "luxon";
import QRCode from "qrcode";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import numbers from 'numeros_to_words';

export class Factura {
    static imprimir(factura: any, cliente: any, duplicado = false): Promise<any> {
        return new Promise((resolve, reject) => {
            const otroIngreso = this.getOtroIngreso(factura.detalle);
            if (factura.cuf == '0' || factura.cuf == null || factura.cuf == undefined || factura.cuf == '') {
                QRCode.toDataURL(`1010413026|${factura.nroFactura}|${factura.renta}|${this.setFecha(factura.fecha)}|${factura.total}|${factura.total}|${factura.codigoControl}|${cliente.ci}|0|0|0|0`).then(url => {
                    factura.img = url;
                    resolve(this.facturaFormato(factura, cliente, otroIngreso, 'antiguo', factura.renta, duplicado))
                }).catch(err => {
                    reject(err)
                })
            } else {
                let cuf = '';
                for (let i = 0; i < factura.cuf.length; i++) {
                    if ((i + 1) % 20 == 0) {
                        cuf += factura.cuf.substring(i, i + 1) + "<br>";
                    } else {
                        cuf += factura.cuf.substring(i, i + 1);
                    }
                }
                QRCode.toDataURL(process.env.VUE_APP_URLSIAT + "&cuf=" + factura.cuf + "&numero=" + factura.nroFactura + '&t=2').then(url => {
                    factura.img = url;
                    resolve(this.facturaFormato(factura, cliente, otroIngreso, 'nuevo', cuf, duplicado))
                }).catch(err => {
                    reject(err)
                })
            }
        });
    }

    static setFecha(fecha: string): string {
        if (fecha == null || fecha == undefined || fecha == '') {
            return '';
        }
        return DateTime.fromISO(fecha).toFormat('dd/MM/yyyy');
    }
    static round(value: number): string {
        return (Math.round(value * 100) / 100).toFixed(2);
    }

    static setFechaHora(fecha: string): string {
        if (fecha == null || fecha == undefined || fecha == '') {
            return '';
        }
        fecha=fecha.replace(' ','T');
        return DateTime.fromISO(fecha).toFormat('dd/MM/yyyy HH:mm:ss');
    }

    static setHora(): string {
        return DateTime.now().toFormat('HH:mm:ss');
    }

    static getOtroIngreso(detalle: any[]) {
        let otrosIngresos = 0
        for (let i = 0; i < detalle.length; i++) {
            if (detalle[i].codigoProducto != '411004') {
                otrosIngresos += parseFloat(detalle[i].precioUnitario)
            }
        }
        return Math.round(otrosIngresos * 100) / 100;
    }

    static facturaFormato(factura: any, cliente: any, otrosIngresos: number, tipo: string, autorizacion: string, duplicado: boolean) {
        // console.log(duplicado);
        console.log(factura);
        let codigoControl=""
        numbers().Config._setSingular('');
        numbers().Config._setPlural('');

        let detalle = ""
        // let subtotal = ""
        for (let i = 0; i < factura.detalle.length; i++) {
            // subtotal=Number(factura.detalle[i].precioUnitario).toFixed(2)
            const cantidad=Number(factura.detalle[i].cantidad==undefined?'1':factura.detalle[i].cantidad)
            detalle += `<tr>
                      <td style='border: 0px;margin: 0px;padding: 0px;text-align: center'>${factura.detalle[i].codigoProducto}</td>
                      <td style='border: 0px;margin: 0px;padding: 0px;'>${factura.detalle[i].descripcion}</td>
                      <td style='border: 0px;margin: 0px;padding: 0px;text-align: right;padding-right: 15px'>${cantidad}</td>
                      <td style='border: 0px;margin: 0px;padding: 0px;text-align: right;padding-right: 15px'>${this.round(factura.detalle[i].precioUnitario)}</td>
                    </tr>`
        }
        const literal = numbers( Math.trunc(factura.total)).toString();
        const centavos = Math.round((factura.total - Math.trunc(factura.total))*100);
        const textoIva = "ACTIVIDAD Servicio y/o Actividades sujetos a IVA";
        let  actividadText=parseInt(factura.tarifa) > 202204 || factura.tarifa=="" || factura.tarifa == null || factura.estado == 'D' ?'Actividad: Captación, depuración y Distribución de Agua':textoIva
        if ((factura.lecturaActual == null || factura.lecturaActual == undefined || factura.lecturaActual == '') && factura.estado != 'D' ) {
           actividadText = textoIva
        }
        const lavate="LÁVATE LAS MANOS CON FRECUENCIA CON AGUA Y JABÓN DURANTE AL MENOS 20 segundos";
        if (tipo=='antiguo'){
            codigoControl=`<div style='font-size: 8px'> <b>C. CONTROL: </b>${factura.codigoControl}<b> F. LIMITE DE EMISION: </b>${factura.flim} <b style="padding-left: 80px"> Caja:</b>${cliente.ventanilla} / ${factura.correlativoDiaCajero==undefined?0:factura.correlativoDiaCajero} </div>`
        }else{
            let anio=''
            let mesText=''
            if (factura.tarifa=="OTROS INGRESOS"){
                mesText="OTROS INGRESOS"
            }else if (factura.tarifa!=undefined && factura.tarifa!=''){
                const mes= parseInt( (factura.tarifa.substring(4,6)))
                anio=parseInt( (factura.tarifa.substring(0,4))).toString()
                const meses=['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
                mesText=meses[mes-1]
            }

            let detalles=''
            factura.detalle.forEach((item:any)=>{
                detalles += `
                <tr>
                <td class="p2 border">${item.codigoProducto}</td>
                    <td class="p2 border right">${item.cantidad}</td>
                    <td class="p2 border">UNIDAD (SERVICIOS)</td>
                    <td class="p2 border">${item.descripcion}</td>
                    <td class="p2 border right">${this.round(item.precioUnitario)}</td>
                    <td class="p2 border right">0</td>
                    <td class="p2 border right">${item.precioUnitario}</td>
                    </tr>`;
            })
            let extencion=''
            if (factura.pla_nan1 != '' && factura.pla_nan1 != undefined && factura.pla_nan1 != null) {
                extencion=`-${factura.pla_nan1}`
            }
            console.log('extencion',extencion);
            return `
<html>
<head>
<meta http-equiv='content-type' content='text/html; utf-8'>
<style>
    .bold{font-weight: bold;}
    .text-h1{font-size: 20px;}
    .text-h5{font-size: 8px;}
    .text-h6{font-size: 7px;}
    .p2{padding: 2px}
    .underline{text-decoration: underline;}
    .center{text-align: center;}
    .right{text-align: right;}
    .border{border: 1px solid black}
    .collapse{border-collapse: collapse;}
    .background{background: #edf2f7}
    .overflow-visible {white-space: initial;}
</style>
</head>
<body>
<div style="position: absolute;left: 1px;width: 195mm;padding: 0.5cm;font-size: 11px;font-family: sans-serif;">
<table width="100%"  class="collapse" >
    <tr>
        <td width="33%">
            <div class="p2 bold center">SERVICIO LOCAL DE ACUEDUCTOS Y ALCANTARILLADO ORURO</div>
            <div class="p2 bold center">CASA MATRIZ</div>
            <div class="p2 center">No. Punto de Venta 0</div>
        </td>
        <td></td>
        <td width="120px">
            <table>
                <tr>
                    <td valign=top width="130px">
                        <div class="p2 bold">NIT</div>
                        <div class="p2 bold">FACTURA N°</div>
                        <div class="p2 bold">CÓD. AUTORIZACIÓN</div>
                    </td>
                    <td>
                        <div>1010413026</div>
                        <div>${factura.nroFactura.padStart(10, 0)}</div>
                        <div style="width: 120px">${autorizacion}</div>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            <div class="p2 center">
                AV. Villarroel N° 222 entre Backovic y Brasil
            </div>
            <div class="p2 center">Telefono de Reclamo:71880887-5235947</div>
            <div class="p2 center">Oruro</div>
            <div class="p2 center">${lavate}</div>
        </td>
        <td></td>
        <td>
            ${actividadText}
        </td>
    </tr>
    <tr>
        <td colspan="3">
            <div class="p2 bold center text-h1 ${duplicado?'underline':''}">
                FACTURA
            </div>
            <div class="p2 center">
                (Con Derecho a Crédito Fiscal)
            </div>
        </td>
    </tr>
    <tr>
        <td colspan="2">
            <table width="100%">
                <tr><td><div class="p2 bold">Nro:</div></td><td><div>${factura.nfac==null?'':factura.nfac}</div></td></tr>
                <tr><td><div class="p2 bold">Nombre/Razón Social:</div></td><td><div>${cliente.razon_social}</div></td></tr>
                <tr><td><div class="p2 bold">Dirección:</div></td><td><div>${cliente.direccion}</div></td></tr>
                <tr><td><div class="p2 bold">Nro. Medidor:</div></td><td><div>${cliente.medidor}</div></td></tr>
                <tr><td><div class="p2 bold">Categoría:</div></td><td><div>${factura.categoria==null?'':factura.categoria}</div></td></tr>
                <tr><td><div class="p2 bold">Periodo:</div></td><td><div>${mesText}/${anio}</div></td></tr>
                <tr><td><div class="p2 bold">Lectura Actual-Fecha:</div></td><td><div>${factura.lecturaActual==null?'':factura.lecturaActual} - ${this.setFecha(factura.fechaLecturaActual)}</div></td></tr>
                <tr><td><div class="p2 bold">Fecha y hora de pago: </div></td><td><div>${factura.fecha_hora_pago}</div></td></tr>
                </tr>
            </table>
        </td>
        <td>
            <table width="100%">
                <tr><td class="p2 right"><div class="p2 bold">Fecha de emisión: </div></td><td><div>Oruro, ${this.setFecha(factura.fecha)}</div></td></tr>
                <tr><td class="p2 right"><div class="p2 bold">NIT/CI/CEX:</div></td><td><div>${factura.planilla_rucnit}</div></td></tr>
                <tr><td class="p2 right"><div class="p2 bold">Cuenta:</div></td><td><div style="font-size: 14px;">${cliente.cuenta==undefined?'':cliente.cuenta}</div></td></tr>
                <tr><td class="p2 right"><div class="p2 bold">Catastro/Circuito:</div></td><td><div>${cliente.catastro}/${cliente.circuito}</div></td></tr>
                <tr><td class="p2 right"><div class="p2 bold">Actividad:</div></td><td><div>${cliente.actividad}</div></td></tr>
                <tr><td class="p2 right"><div class="p2 bold">Tipo Consumo:</div></td><td><div>${factura.descripcionConsumo==undefined?'':factura.descripcionConsumo}</div></td></tr>
                <tr><td class="p2 right"><div class="p2 bold">Lectura Anterior-Fecha:</div></td><td><div>${factura.lecturaAnterior==null?'':factura.lecturaAnterior} - ${this.setFecha(factura.fechaLecturaAnterior)}</div></td></tr>
            </table>
        </td>
    </tr>
    <tr>
        <td colspan="3">
            <table width="100%" class="p2 collapse">
                <tr class="p2 background" >
                    <th class="p2 border" width="50px" >CÓDIGO
                        SERVICIO</th>
                    <th class="p2 border">CANTIDAD</th>
                    <th class="p2 border">UNIDAD DE
                        MEDIDA</th>
                    <th class="p2 border">DESCRIPCIÓN</th>
                    <th class="p2 border" width="60px">PRECIO
                        UNITARIO</th>
                    <th class="p2 border">DESCUENTO</th>
                    <th class="p2 border">SUBTOTAL</th>
                </tr>
                ${detalles}
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">TOTAL Bs</td>
                    <td class="p2 border right">${this.round(factura.total)}</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">(-) DESCUENTO Bs</td>
                    <td class="p2 border right">0</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">SUBTOTAL A PAGAR Bs</td>
                    <td class="p2 border right">${this.round(factura.total)}</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">(-) AJUSTES NO SUJETOS A IVA Bs</td>
                    <td class="p2 border right">0</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5 bold background" colspan="2">MONTO TOTAL A PAGAR Bs</td>
                    <td class="p2 border right">${this.round(factura.total)}</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">(-) TASAS Bs</td>
                    <td class="p2 border right">0</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">(-) OTROS PAGOS NO SUJETO IVA Bs</td>
                    <td class="p2 border right">0</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right text-h5" colspan="2">(+) AJUSTES NO SUJETOS A IVA Bs</td>
                    <td class="p2 border right">0</td>
                </tr>
                <tr>
                    <td colspan="4"></td>
                    <td class="p2 border right  text-h5 bold background" colspan="2">IMPORTE BASE CRÉDITO FISCAL</td>
                    <td class="p2 border right">${this.round(factura.total)}</td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td colspan="3" >
            <table width="100%">
                <tr>
                    <td class="p2 center" valign=top>
                        <div class="p2 left bold">Son: ${literal} CON ${centavos}/100 BOLIVIANOS</div>
                        <div class="p2 text-h5">
                        “Cierra el grifo de la violencia contra la mujer”
                        </div>
                        <div class="p2 text-h5">
                        ESTA FACTURA CONTRIBUYE AL DESARROLLO DEL PAÍS, EL USO ILÍCITO SERÁ SANCIONADO PENALMENTE DE ACUERDO A LEY
                        </div>
                        <div class="p2 text-h5">${factura.leyenda}</div>
                        <div class="p2 text-h5">“Este documento es la Representación Gráfica de un Documento Fiscal Digital emitido en una modalidad de facturación en línea”</div>
                        <div class="p2 right"><b>CAJA:</b> ${cliente.ventanilla} / ${factura.correlativoDiaCajero==undefined?0:factura.correlativoDiaCajero}</div>
                    </td>
                    <td>
                        <img src='${factura.img}' width='89px'>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td colspan="3" class="">
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>    
            <table class='tablex' style='width: 100%;min-width: 100%;max-width: 100%;border: 1px solid black' >
              <tr class='trx' valign='top'>
                <td class='tdx' style='height: 50px;width: 50%;min-width: 50%;max-width: 50%'>
                  <b>CAJA: </b>${cliente.ventanilla} / ${factura.correlativoDiaCajero==undefined?0:factura.correlativoDiaCajero} - ${factura.nfac == null ? '' : factura.nfac}<br><br>
                  <b>FECHA: </b>${this.setFecha(factura.fecha)}<br><br>
                  <b>HORA: </b> ${this.setFechaHora(cliente.fecha.date.substring(0, 19))} <br><br>
                </td>
                <td class='tdx' style='height: 50px;width: 50%;min-width: 50%;max-width: 50%'>
                  <b>Cuenta: </b>${cliente.cuenta==undefined?'':cliente.cuenta} - ${factura.nroFactura} / ${factura.nfac == null ? '' : factura.nfac}<br><br>
                  <b>Nombre/Razón Social: </b><small style='font-size: 9px'> ${cliente.razon_social}</small><br><br>
                  <b>TOTAL A PAGAR: </b>  ${this.round(factura.total)}<br><br>
                </td>
              </tr>
            </table>
        </td>
    </tr>
</table>
</div>
</body>
</html>
`;
        }
        return `
            <style>
            .tablex, .tdx, .thx { border: 1px solid #BDBDBD; }
            .tablex {width: 100%;border-collapse: collapse;}
            </style>
            <div style='position: absolute;left: 10px;width: 195mm;padding: 0.1cm 0.3cm;font-size: 10px;font-family: sans-serif'>
                <table class='tablex' style='width: 100%;border:2px solid white'>
                  <tr>
                    <td style='width: 33%;border: 2px solid white' >
                      <div style='text-align:center;font-weight:  bold'>Servicio Local de Acueductos y Alcantarillado Oruro</div>
                      <div style='text-align:center;font-weight:  bold'>CASA MATRIZ</div>
                      <div style='text-align:center'>Av. Villarroel N 222 entre Backovic y Brasil</div>
                      <div style='text-align:center'>Zona Nor este Telfs: 52 35947-718 80887</div>
                      <div style='text-align:center'>Oruro</div>
                    </td>
                    <td style='width: 33%;border: 2px solid white'></td>
                    <td style='width: 33%;border: 2px solid white' valign='top'>
                      <div><span style='text-align:left;font-weight:  bold'>NIT: </span>1010413026</div>
                      <div><span style='text-align:left;font-weight:  bold'>FACTURA Nº: </span>${factura.nroFactura}</div>
                      <div><span style='text-align:left;font-weight:  bold'>Autorización Nº: </span>${autorizacion}</div>
                    </td>
                    </tr>
                    <tr>
                    <td style='width: 33%;border: 2px solid white'>
                      <div style='text-align:left;font-weight:  bold;font-size: 8px'>${lavate}</div>
                    </td>
                    <td style='width: 33%;border: 2px solid white' valign='top'>
                      <div style='text-align:center;font-weight:  bold;font-size: 25px;text-decoration: ${duplicado?'underline':''}'>FACTURA</div>
                      <div style='text-align: center;font-weight: normal'>(Con derecho a Crédito Fiscal)</div>
                    </td>
                    <td style='width: 33%;border: 2px solid white'>
                      <div style='text-align:left;font-weight:  bold'>${actividadText}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style='width: 33%;border: 2px solid white'>
                      <div style='text-align:left;font-weight:  bold'>N°:${factura.nfac == null ? '' : factura.nfac}</div>
                    </td>
                    <td style='width: 33%;border: 2px solid white' valign='top'>
                      <div><span style='text-align:center;font-weight:  bold'>Fecha de Emisión: </span>${this.setFecha(factura.fecha)}</div>
                    </td>
                    <td style='width: 33%;border: 2px solid white'>
                    </td>
                  </tr>
                </table>
                <table class='tablex' style='width: 144mm;min-width: 144mm;max-width: 144mm' > 
                  <tr class='trx' style='visibility: hidden'>
                    <th class='thx' style='width: 43mm;min-width: 43mm;max-width: 43mm;border: 1px solid white'>
                      <div style='text-align:center;font-weight:  bold'>CI</div>
                    </th>
                    <th class='thx' style='width: 74mm;min-width: 74mm;max-width: 74mm;border: 1px solid white'>
                      <div style='text-align:center;font-weight:  bold'>CI</div>
                    </th>
                    <th class='thx' style='width: 39mm;min-width: 39mm;max-width: 39mm;border: 1px solid white'>
                      <div style='text-align:center;font-weight:  bold'>CI</div>
                    </th>
                    <th class='thx' style='width: 39mm;min-width: 39mm;max-width: 39mm;border: 1px solid white'>
                      <div style='text-align:center;font-weight:  bold'>CI</div>
                    </th>
                  </tr>
                  <tr class='trx' >
                    <td class='tdx' height='20' colspan='2'><b>Nombre/Razón Social:</b>  <small style='font-size: 8px'>${cliente.razon_social}</small></td>
                    <td class='tdx'  valign='top' style=''><div style='font-weight: bold;text-align: center'>NIT/C.I./CEX</div> 
                        <div style="text-align: center">${factura.planilla_rucnit}</div> 
                    </td>
                    <td class='tdx' rowspan='2' valign='top'>
                        <b>Cuenta:</b>
                        <br>
                        <div style="text-align: center">${cliente.cuenta}</div>
                  </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' height='20' colspan='3'><b>Dirección:</b>  <small style='font-size: 8px'>${cliente.direccion}</small></td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' style='width: 10%;'>
                    <b>Periodo a Facturar</b>
                        <div style="text-align: center;width: 100%">${factura.tarifa == null ? '' : factura.tarifa}</div>
                    </td>
                    <th class='thx' colspan='2'>Liquidación de servicio a pagar</th>
                    <td class='tdx' valign='top'>
                      <b>Código Catastro</b>
                       <div style="text-align: center">${cliente.catastro}</div> 
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx'><b style='font-size: 8px'>${cliente.categoria }</b> <br> ${ cliente.actividad }</td>
                    <td class='tdx' colspan='2' rowspan='9' valign='top'>
                      <table class='tablex' width='100%' style='border: 0px;margin: 0px;padding: 0px;'>
                        <tr class='trx' style='border: 0px;margin: 0px;padding: 0px;'>
                          <th class='thx' style='border: 0px;margin: 0px;padding: 0px;'>Código</th>
                          <th class='thx' style='border: 0px;margin: 0px;padding: 0px;'>Descripción</th>
                          <th class='thx' style='border: 0px;margin: 0px;padding: 0px;text-align: center'>Cantidad</th>
                          <th class='thx' style='border: 0px;margin: 0px;padding: 0px'>Valor</th>
                        </tr>${detalle}
                        <tr class='trx'>
                          <td class='tdx' style='height: 35px;border: 2px solid white'></td>
                        </tr>
                        <tr class='trx'>
                          <td class='tdx' style='height: 35px;border: 2px solid white' colspan='4'>${factura.glosa == undefined ? 'Sr(a). usuario(a) 2 facturas no pagadas generan multa y corte del servicio, favor no descuide sus pagos mensuales' : factura.glosa}</td>
                        </tr>
                      </table>
                    </td>
                    <td class='tdx' valign='top'>
                        <b>Nº Medidor</b>
                        <div style="text-align: center">${cliente.medidor}</div>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx'>
                      <table class='tablex' style='border: 0px ;margin:0px;padding:0px;'>
                        <tr class='trx' style='border: 0px ;margin:0px;padding:0px;' >
                          <th class='thx' style='border: 0px ;margin:0px;padding:0px;height: 25px'><div style='font-size: 5px'>Lectura Actual</div><br>${factura.lecturaActual == null ? '' : factura.lecturaActual}</th>
                          <th class='thx' style='border: 0px ;margin:0px;padding:0px;height: 25px'><div style='font-size: 5px'>Lectura Anterior</div><br>${factura.lecturaAnterior == null ? '' : factura.lecturaAnterior}</th>
                          <th class='thx' style='border: 0px ;margin:0px;padding:0px;height: 25px'><div style='font-size: 5px'>Meses Deuda</div><br>${factura.mesesDeuda == null ? '' : factura.mesesDeuda}</th>
                        </tr>
                        <tr>
                          <td style='border: 0px ;margin:0px;padding:0px;text-align: center'><small style='font-size: 7px'>${factura.fechaLecturaActual == null ? '' : this.setFecha(factura.fechaLecturaActual)}</small></td>
                          <td style='border: 0px ;margin:0px;padding:0px;text-align: center'><small style='font-size: 7px'>${factura.fechaLecturaAnterior == null ? '' : this.setFecha(factura.fechaLecturaAnterior)}</small></td>
                       </tr>
                      </table>
                    </td>
                    <td class='tdx'>
                      <b>Circuito Hidráulico</b>
                      <div style="text-align: center">${cliente.circuito}</div>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' valign='top'>
                      <b>Tipo Consumo:</b> <br>${factura.descripcionConsumo == null ? '' : factura.descripcionConsumo}
                    </td>
                    <td class='tdx' style='text-align: center'>
                      Apreciado Cliente: <br>
                      El resumen de su factura es el siguiente:
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' rowspan='3' valign='top'><b>Historico de Consumo:</b></td>
                    <td class='tdx'>
                      <b>Servicio de Agua:</b>
                      <div style="text-align: center">${factura.servicioAgua == null ? '' : factura.servicioAgua}</div>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' height='30px'>
                      <b>Alcantarillado:</b> <br>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx'>
                      <b>Otros Ingresos:</b>
                      <div style="text-align: center">${otrosIngresos.toFixed(2)}</div>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' rowspan='3'>
                      <b>SeLA Informa:</b><br>
                      El uso del medidor en la instalación de agua potable es de responsabilidad del usuario, por lo que se recomienda que se realice el mantenimiento preventivo y correctivo de acuerdo a las normas técnicas vigentes.
                    </td>
                    <th class='thx'>
                      TOTAL A PAGAR: <br>
            ${this.round(factura.total)}
                    </th>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx'>
                      <b>ÚLTIMO DÍA DE PAGO</b>
                      <div style="text-align: center">${factura.fechaVencimiento==null || factura.fechaVencimiento==undefined?'':this.setFecha(factura.fechaVencimiento)}</div>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx'>
                      <b>Fecha y hora de pago</b>
                      <div style="text-align: center">${factura.fecha_hora_pago}</div>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' colspan='4' height='20px'>
                      <b>SON:</b>${literal} CON ${centavos}/100 BOLIVIANOS
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' colspan='3' style='text-align: center' height='30px'>
                      <div style='font-size: 6px'>'ESTA FACTURA CONTRIBUYE AL DESARROLLO DEL PAÍS. EL USO ILÍCITO DE ÉSTA SERÁ SANCIONADO DE ACUERDO A LEY'</div>
                      <div style='font-size: 8px'>${factura.leyenda}</div>
            ${codigoControl} 
                    </td>
                    <td class='tdx' rowspan='2' style='text-align: center'>
                      <img src='${factura.img}' width='89px'>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' colspan='3' style='text-align: center'>
                      <table class='tablex' style='border: 2px solid white'>
                        <tr class='trx'>
                          <td class='tdx' style='border: 2px solid white'>
                            <!--img src='img/aaps1.jpg' width='345' height='85px' style=''-webkit-filter: grayscale(100%);filter: grayscale(100%);'-->
                            “Cierra el grifo de la violencia contra la mujer”
                          </td>
                          <td class='tdx' style='border: 2px solid white'>
                            <!--img src='img/aaps2.jpg' width='105px' height='85px' style=''-webkit-filter: grayscale(100%);filter: grayscale(100%);'-->
                          </td>

                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr class='trx'>
                    <td class='tdx' colspan='4' >
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                <table class='tablex' style='width: 100%;min-width: 100%;max-width: 100%' >
                  <tr class='trx' valign='top'>
                    <td class='tdx' style='height: 50px;width: 50%;min-width: 50%;max-width: 50%'>
                      <b>CAJA: </b>${cliente.ventanilla} / ${factura.correlativoDiaCajero==undefined?0:factura.correlativoDiaCajero} - ${factura.nfac == null ? '' : factura.nfac}<br><br>
                      <b>FECHA: </b>${this.setFecha(factura.fecha)}<br><br>
                      <b>HORA: </b> ${this.setFechaHora(cliente.fecha.date.substring(0, 19))} <br><br>
                    </td>
                    <td class='tdx' style='height: 50px;width: 50%;min-width: 50%;max-width: 50%'>
                      <b>Cuenta: </b>${cliente.cuenta} - ${factura.nroFactura} / ${factura.nfac == null ? '' : factura.nfac}<br><br>
                      <b>Nombre/Razón Social: </b><small style='font-size: 9px'> ${cliente.razon_social}</small><br><br>
                      <b>TOTAL A PAGAR: </b>  ${this.round(factura.total)}<br><br>
                    </td>
                  </tr>
                </table>
                    </td>
                  </tr>
                </table>

              </div>`
    }
}
